import React, { useEffect, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import { Fade, Tooltip } from '@mui/material'
import { makeStyles } from '@mui/styles'

import createLogger from '~/src/Lib/Logging'
import { useResizeObserver } from '~/src/Lib/Utils'

const displayName = 'Harvest/OverflowTooltip'
const logger = createLogger(displayName)

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'hidden',
  },
  content: {
  },
  tooltip: {
    background: theme.palette.background.dark,
    border: `1px solid ${theme.palette.gray}`,
    marginLeft: '-9px',
  },
}), { name: displayName })

const OverflowTooltip = ({ children }) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const contentEl = useRef(null)
  const { ref, width, height } = useResizeObserver()

  useEffect(() => {
    const { current: content } = contentEl
    if (!content) return
    const toCheck = Array.from(content.children).flatMap(el => [el, ...Array.from(el.children)])
    toCheck.unshift(content)

    setShowTooltip(
      content && toCheck.some(el => el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight)
    )
  }, [width, height])

  const classes = useStyles()

  const content = (
    <div className={classes.content} ref={contentEl}>
      {children}
    </div>
  )

  return (
    <div className={classes.root} ref={ref}>
      {showTooltip ? (
        <Tooltip
          enterDelay={0}
          placement="bottom-start"
          title={content}
          classes={{ tooltip: classes.tooltip }}
          sx={{
            '& .MuiTooltip-tooltip': {
              marginTop: height ? `${-height - 5}px` : '-4.25rem',
            }
          }}
          TransitionComponent={Fade}
        >
          {content}
        </Tooltip>
      ) : content}
    </div>
  )
}

OverflowTooltip.propTypes = {
  children: PropTypes.node.isRequired,
}

export default OverflowTooltip
